import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { getAgencies } from "common/services/agencies.service";
import { normalize } from "common/lib/normalize";

const FIELD = "leadAgency";

/** The UN agency that established the agreement and owns the relationship. */
const SelectLeadAgency = ({ validation }: { validation: any }) => {
  const invalid = validation.touched[FIELD] && validation.errors[FIELD];

  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: invalid ? "red" : "#ced4da",
      borderRadius: ".25rem",
      "&:hover": {
        borderColor: invalid ? "red" : "#ced4da",
        borderRadius: ".25rem",
      },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getAgencies({
          pagination: { page: 1, pageSize: 10000 },
          filters: { category: { $null: false } },
          sort: ["name"],
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(
    () => data.map((el: any) => ({ value: el?.id, label: el?.name })),
    [data]
  );

  return (
    <FormGroup className="mb-0">
      <Label htmlFor="leadAgency-field" className="form-label">
        Lead UN Agency
      </Label>
      <Select
        name={FIELD}
        id={FIELD}
        value={validation.values[FIELD]?.value ? validation.values[FIELD] : null}
        placeholder="Select lead agency"
        onChange={(value: any) => {
          validation.setFieldValue(FIELD, value || { value: "", label: "" });
          validation.setFieldError(FIELD, "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched(FIELD, true)}
        className={invalid ? "is-invalid" : ""}
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors[FIELD]?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectLeadAgency;
